import React from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem, Button, CircularProgress } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import 'dayjs/locale/es-mx';

dayjs.locale('es-mx');

interface SEARCH_FILTERSProps {
    setValueSelect: (value: string) => void;
    valueSelect: string;
    handle_search: () => void;
    fi: any;
    ff: any;
    setfi: (value: any) => void;
    setff: (value: any) => void;
}

const SEARCH_FILTERS: React.FC<SEARCH_FILTERSProps> = (props) => {
    const { valueSelect, setValueSelect, handle_search, fi, ff, setfi, setff } = props;

    const data_select = [
        { value: "TODOS" },
        { value: "ABIERTO" },
        { value: "REVISION" },
        { value: "CERRADO" },
        { value: "CANCELADO" },
    ];

    const handleChange = (newValue: string) => {
        setValueSelect(newValue);
    };

    return (
        <Box className="controlInvoice" sx={{ display: 'flex', gap: '5px', p: '2px', zIndex: "10", alignItems: 'flex-start' }}>
            {/* Fecha Inicial */}
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es-mx">
                <DatePicker
                    label="Fecha Inicial"
                    value={fi}
                    onChange={setfi}
                    sx={{ width: 160 }}
                />
            </LocalizationProvider>

            {/* Fecha Final */}
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es-mx">
                <DatePicker
                    label="Fecha Final"
                    value={ff}
                    onChange={setff}
                    sx={{ width: 160 }}
                />
            </LocalizationProvider>

            {/* Estado Select */}
            <FormControl sx={{ width: 150 }}>
                <InputLabel id="estado-label">Estado</InputLabel>
                <Select
                    labelId="estado-label"
                    id="estado-select"
                    value={valueSelect}
                    label="Estado"
                    onChange={(e) => handleChange(e.target.value)}
                    sx={{ height: '35px' }}
                >
                    {data_select.map((option, index) => (
                        <MenuItem key={index} value={option.value}>
                            {option.value}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            {/* Botón de buscar */}
            <FormControl>
                <Button
                    variant="contained"
                    onClick={handle_search}
                    sx={{ height: '35px' }}
                >
                    Buscar
                </Button>
            </FormControl>
        </Box>
    );
};

export default SEARCH_FILTERS;
